import { nsTerminal } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import POS_TERMINAL_STATUS from '../enums/PosTerminalStatus';

/**
 * Get the manufacturer item from the selected value in the form
 * @param {String} manufacturerFieldValue Manufacturer selected in the form
 * @param {Array} manufacturersList List of manufacturers
 * @returns {Object} Manufacturer object
 */
const getSelectedManufacturerInForm = (manufacturerFieldValue, manufacturersList) => {
    if (!manufacturerFieldValue || !manufacturersList) {
        return undefined;
    }

    return manufacturersList.find(manufacturerItem => manufacturerItem.value === manufacturerFieldValue);
};

export default {
    UUID: {
        key: 'uuid'
    },
    STATUS: {
        key: 'status',
        entity: 'keys.status',
        type: FIELD_TYPES.BADGE,
        enum: POS_TERMINAL_STATUS,
        namespace: nsTerminal
    },
    SERIAL_NUMBER: {
        key: 'serialNumber',
        type: (props, values = {}) => {
            const manufacturer = getSelectedManufacturerInForm(values.manufacturer, props.manufacturersList);

            if (!manufacturer) {
                return 'text';
            }
            const regexTest = Number(`1e+${manufacturer.length - 1}`);
            return manufacturer.regex.test(regexTest) ? 'tel' : 'text';
        },
        entity: 'modal.info_status.serial_number',
        namespace: nsTerminal
    },
    MANUFACTURER: {
        key: 'manufacturer',
        type: 'select',
        entity: 'modal.info_status.manufacturer',
        namespace: nsTerminal
    },
    LABEL: {
        key: 'label',
        entity: 'keys.label',
        namespace: nsTerminal
    },
    CUSTOM_LABEL: {
        key: 'customLabel',
        entity: 'keys.custom_label',
        namespace: nsTerminal
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.created_at',
        namespace: nsTerminal
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.updated_at',
        namespace: nsTerminal
    },
    BLACKLIST_START_DATE: {
        key: 'blacklistStartDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.blocked_at',
        namespace: nsTerminal
    },
    REWAREHOUSE_DATE: {
        key: 'rewarehousedAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.rewarehouse_at',
        namespace: nsTerminal
    },
    CONNECTION_POINTS: {
        key: 'connectionPoints',
        type: FIELD_TYPES.ARRAY,
        UUID: {
            parentKeys: ['connectionPoints'],
            key: 'uuid',
            type: FIELD_TYPES.TEXT
        },
        IP_ADDRESS: {
            parentKeys: ['connectionPoints'],
            key: 'ipAddress',
            type: FIELD_TYPES.TEXT
        },
        PORT: {
            parentKeys: ['connectionPoints'],
            key: 'port',
            type: FIELD_TYPES.TEXT
        },
        INSTANCE_TAG: {
            parentKeys: ['connectionPoints'],
            key: 'instanceTag',
            type: FIELD_TYPES.TEXT
        }
    },
    // info status posTerminal
    STATUS_IN_DATEBASE: {
        key: 'posTerminalDatabaseStatus',
        type: FIELD_TYPES.BADGE,
        entity: 'modal.info_status.portal',
        namespace: nsTerminal,
        enum: POS_TERMINAL_STATUS
    },
    REDIS_BLACKLIST_FETCHING_TIME: {
        key: 'redisKeyFetchDuration',
        type: 'fetchingTime',
        entity: 'modal.info_status.fetching_time',
        namespace: 'terminal'
    },
    REDIS_KEYS_FETCHED: {
        key: 'redisKeysFetched',
        entity: 'posTerminal_info_status_key_list_redis',
        REDIS_KEY: {
            parentKeys: ['redisKeysFetched'],
            key: 'key',
            type: FIELD_TYPES.TEXT,
            namespace: nsTerminal,
            entity: 'modal.info_status.connexion_point'
        },
        REDIS_VALUE: {
            parentKeys: ['redisKeysFetched'],
            key: 'value',
            type: FIELD_TYPES.OBJECT,
            namespace: nsTerminal,
            entity: 'modal.info_status.value'
        },
        REDIS_STATUS: {
            parentKeys: ['redisKeysFetched'],
            key: 'status',
            type: FIELD_TYPES.BADGE,
            namespace: nsTerminal,
            entity: 'modal.info_status.status'
        },
        REDIS_START_DATE: {
            parentKeys: ['redisKeysFetched'],
            key: 'startDate',
            type: FIELD_TYPES.DATE,
            namespace: nsTerminal,
            entity: 'modal.info_status.starting_date'
        }
    }
};